export default __webpack_public_path__ + "static/media/bc-third.29d3cd34.svg";